import { useRef } from "react";
import { motion, useInView } from "framer-motion";

// Gradient text wrapped around per-char animated spans breaks
// background-clip:text on Safari (word vanishes). Gradient words therefore
// get a single-element masked reveal — the gradient lives on the moving
// element itself, which is safe cross-browser.
export const GradientWord = ({ text, light = false, delay = 0, inView = false, className = "" }) => {
  const ref = useRef(null);
  const on = useInView(ref, { once: true, margin: "-40px" });
  const show = inView ? on : true;
  return (
    <span ref={ref} className="inline-block overflow-hidden pb-[0.1em] align-bottom">
      <motion.span
        className={`inline-block bg-gradient-to-r bg-clip-text italic text-transparent ${
          light ? "from-[#B8860B] via-[#D4AF37] to-[#8B6914]" : "from-[#D4AF37] via-[#F3E5AB] to-[#AA7C11]"
        } ${className}`}
        initial={{ y: "112%" }}
        animate={{ y: show ? 0 : "112%" }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay }}
      >
        {text}
      </motion.span>
    </span>
  );
};

export const SplitText = ({ text, className = "", delay = 0, stagger = 0.035, inView = false, testid }) => {
  const ref = useRef(null);
  // One observer on the wrapper (reliable) instead of per-char whileInView.
  const on = useInView(ref, { once: true, margin: "-40px" });
  let idx = 0;
  return (
    <span ref={ref} className={className} aria-label={text} data-testid={testid}>
      {String(text)
        .split(" ")
        .map((word, wi) => (
          <span key={wi} className="inline-block whitespace-nowrap" aria-hidden="true">
            {word.split("").map((c, ci) => {
              const d = delay + idx++ * stagger;
              return (
                <span key={ci} className="inline-block overflow-hidden pb-[0.08em] align-bottom">
                  <motion.span
                    className="inline-block"
                    initial={{ y: "115%" }}
                    animate={{ y: inView ? (on ? 0 : "115%") : 0 }}
                    transition={{ duration: 0.7, ease: [0.34, 1.56, 0.64, 1], delay: d }}
                  >
                    {c}
                  </motion.span>
                </span>
              );
            })}
            <span className="inline-block">&nbsp;</span>
          </span>
        ))}
    </span>
  );
};
